import React from "react";
import {
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  Link,
  FormHelperText,
} from "@mui/material";

const TermsCheckbox = ({ agreed, onChange, error }) => (
  <Grid item xs={12}>
    <FormControlLabel
      control={
        <Checkbox
          checked={agreed}
          onChange={(e) => onChange(e.target.checked)}
          color="primary"
        />
      }
      label={
        <Typography variant="body2">
          I agree to the{" "}
          <Link href="/terms" target="_blank" underline="hover">
            Terms of Service
          </Link>{" "}
          and{" "}
          <Link href="/privacy" target="_blank" underline="hover">
            Privacy Policy
          </Link>
        </Typography>
      }
    />
    {error && (
      <FormHelperText error sx={{ ml: 0 }}>
        {error}
      </FormHelperText>
    )}
  </Grid>
);

export default TermsCheckbox;
